import * as Illustration from "@npco/zeller-design-system/illustration";

import { ListSteps } from "../../shared/list-steps";
import { PromptBig } from "../../shared/prompt-big";

export function NetworkErrorPrompt() {
	return (
		<PromptBig
			image={<Illustration.ErrorBoatSinking loop={false} />}
			title="Unable to connect to Zeller"
			message={
				<>
					Please ensure this device is connected to the internet.
					<ListSteps
						items={[
							"Confirm your device is connected to your network.",
							"Check if the network is connected to the internet.",
						]}
					/>
				</>
			}
		/>
	);
}
